import React from 'react';
import { InputFieldWithTitles } from '@UI-Elements/Select/InputFieldWithTitles';
import ButtonDesigned from '@UI-Elements/Buttons/ButtonDesigned';
import { IRoute, IRoutePolicy } from '@sp-types/index';
import { CloseButton } from '@UI-Elements/Buttons/CloseButton';

interface Props {
  routePolicies?: IRoutePolicy[];
  route?: IRoute;
  cancelEdit: () => void;
  onSave: (_policy: IRoutePolicy) => void;
}
export const EditRouteSettings: React.FC<Props> = ({ routePolicies, route, cancelEdit, onSave }) => {
  const [policy, setPolicy] = React.useState<IRoutePolicy>(
    routePolicies?.find((r) => r.routeId === route?.id) || ({} as IRoutePolicy),
  );
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (routePolicies) {
      setPolicy(routePolicies.find((r) => r.routeId === route?.id) || ({} as IRoutePolicy));
    }
  }, [routePolicies, route]);

  const isDirty = true;

  const policies = [
    { title: 'value high than Index price by', attribute: 'higherThanIndex' },
    { title: 'next route is lower by more than', attribute: 'lowerThanNext' },
    { title: 'Price higher than lowest route by', attribute: 'higherThanLowest' },
  ];

  const onSaveClick = async (policy: IRoutePolicy) => {
    if (policy.isDirty && route?.id) {
      setIsLoading(true);

      await onSave({ ...policy, routeId: route.id, materialId: route.materialId });

      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-full my-3 px-3 border-l border-l-gray-200">
      <div className="flex flex-col gap-3 w-full border-3 p-3" style={{ borderColor: route?.color || 'transparent' }}>
        {route?.id ? (
          <>
            <div className="flex justify-between text-lg">
              <p>Set conditions</p>
              <CloseButton onClick={cancelEdit} />
            </div>
            <div>
              <p>
                Skip <b>{route?.name}</b> when:
              </p>
            </div>
            {policies.map(({ title, attribute }, key) => (
              <div key={key}>
                <p>{title}</p>
                <div className="flex flex-row gap-1">
                  <p className="text-sm p-1 text-gray-350">US $</p>
                  <div className="w-24">
                    <InputFieldWithTitles
                      value={policy[attribute as keyof IRoutePolicy] as number}
                      changeValueFunc={(val) => setPolicy((_policy) => ({ ..._policy, [attribute]: +val, isDirty }))}
                      isNumeric={true}
                      placeHolder="0"
                    />
                  </div>
                </div>
              </div>
            ))}

            <div className="flex flex-row justify-end gap-3">
              <ButtonDesigned onButtonClick={() => cancelEdit()} style="outline" className="w-24">
                Cancel
              </ButtonDesigned>
              <ButtonDesigned
                onButtonClick={() => onSaveClick(policy)}
                style="primary"
                className="w-24"
                disableButton={!policy.isDirty || isLoading}
                isFunctionLoading={isLoading}
              >
                Save
              </ButtonDesigned>
            </div>
          </>
        ) : (
          <div className="flex flex-col justify-center h-full p-8"> &lt;- Select route for edit</div>
        )}
      </div>
    </div>
  );
};
